import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, CardHeader, CircularProgress } from '@material-ui/core'
import { FaEyeSlash, FaDownload, FaCheck, FaUser } from 'react-icons/fa'
import { IoLogoWhatsapp } from "react-icons/io"
import Fullname from '../../components/Fullname'
import { search } from '../../../store/actions/cotas.action'
import { changeScreenB } from '../../../store/actions/navigation.action'

export default function Detail(props) {
    const dispatch = useDispatch()
    const campaign_id = (props.campaign_id) ? props.campaign_id : null;
    const number = (props.number) ? props.number : null;

    const { result } = useSelector(state => state.cotasReducer)
    const [ telefone, setTelefone ] = React.useState(false)
    const [isLoading, setLoading] = React.useState(true)

    React.useEffect(() => {
        dispatch(search(campaign_id, number, false, false)).then(() => {
            setLoading(false)
        })
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handlePage = (page, user_id = null) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                user_id: user_id
            }
        }))
    }

    return (
        <>
            {isLoading ? <div className="d-flex justify-content-center p-5 bs-bg"><div className="text-center"><CircularProgress /></div></div> :
                <div className="card bs-bg">
                    {(result.cota && result.user) &&
                        <>
                            {(result.cota.number && result.user.name) &&
                                <>
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Cota</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="bg-success">
                                                <FaCheck />
                                            </Avatar>
                                        }
                                        title={<h5 className="fw-bold m-0 bs-color-b">{result.cota.number}</h5>}
                                        subheader={<small className="fw-bold text-success">VENDIDA</small>} 
                                    />

                                    <hr className="hr-muted m-0"/>

                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaUser />
                                            </Avatar>
                                        }
                                        title={<h6 className="fw-bold bs-color-b">{<Fullname fullName={result.user.name ? result.user.name.substring(0,25) : result.user.name} />}</h6>}
                                        subheader={
                                            <>
                                            <div className="d-flex justify-content-between">
                                                <div className="d-flex flex-column mb-2">
                                                    <span className="d-block pointer bs-color" onClick={() => setTelefone(telefone ? false : true)}>{(telefone) ? result.user.telefone : <> {result.user.telefone.substring(5, -1)} ****** <FaEyeSlash /></>}</span>
                                                    {result.transaction?.location &&
                                                        <span className="bs-color">{result.transaction?.location?.estado}</span>
                                                    }
                                                </div>

                                                <span className="me-2">
                                                    <a href={'http://wa.me/55'+result.user.telefone} target="_blank" rel="noopener noreferrer">
                                                        <IoLogoWhatsapp color="#24d366" size={30}/>
                                                    </a>
                                                </span>
                                            </div>

                                            <span onClick={() => handlePage('shopping', result.user.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                            </>
                                        }
                                    /> 

                                    <hr className="hr-muted m-0"/>

                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="avatar-item pointer">
                                                <FaDownload />
                                            </Avatar>
                                        }
                                        title={<h6 className="fw-bold bs-color-b pointer">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(result.transaction.transaction_amount)}</h6>}
                                        subheader={
                                            <>
                                                <span className="d-block bs-color mb-2 pointer">Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(result.cota.paid_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(result.cota.paid_at))}</span>
                                            </>
                                        }
                                    />
                                </>
                            }
                        </>
                    }

                    <div className="d-flex card-body justify-content-center">
                        <button className="btn btn-light fw-bold" onClick={() => props.onClose() }>
                            Fechar
                        </button>
                    </div>
                </div>
            }
        </>
    )
}